import { APP_CONFIG } from "@config/app.config";
import { PurchaseOrderItem } from "@domain/purchasing";
import { Avatar, Checkbox, Chip, ListItem, ListItemButton, Stack, Tooltip, Typography } from "@mui/material";

interface CreateShipmentItemListItemProps {
    item: PurchaseOrderItem;
    selected: boolean;
    onToggle: (item: PurchaseOrderItem) => void;
}

export const CreateShipmentItemListItem: React.FC<CreateShipmentItemListItemProps> = ({
    item,
    selected,
    onToggle,
}) => {
    return (
        <ListItem
            component={ListItemButton}
            sx={{
                borderBottom: 1,
                borderColor: APP_CONFIG.ui.theme.colors.border,
                p: 4,
                gap: 2
            }}
            onClick={() => onToggle(item)}
        >
            <Checkbox
                checked={selected}
                onChange={() => onToggle(item)}
            />

            <Avatar
                src={item.product.image}
                variant="rounded"
                sx={{ width: 50, height: 50, border: 1, borderColor: APP_CONFIG.ui.theme.colors.border }}
            />

            <Stack direction="column" flexGrow={1} gap={1}>
                <Tooltip title={item.product.title}>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'normal',
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: 'vertical',
                            display: '-webkit-box'
                        }}
                    >
                        {item.product.title}
                    </Typography>
                </Tooltip>

                <Stack direction="row" gap={1}>
                    {item.purchaseOrder?.poNumber && (
                        <Chip
                            label={`PO: ${item.purchaseOrder.poNumber}`}
                            color="info"
                            size="small"
                            sx={{ maxWidth: 200 }}
                        />
                    )}


                    <Chip
                        label={item.purchaseOrder?.supplier?.name || 'No supplier'}
                        color="info"
                        size="small"
                        sx={{ maxWidth: 200 }}
                    />

                </Stack>
            </Stack>

            <Stack direction="row" width="100px" justifyContent="flex-end" alignItems="center" spacing={2}>
                <Typography variant="subtitle2" color="text.secondary">
                    {item.quantity || 0} items
                </Typography>
            </Stack>
        </ListItem>
    );
};
